




import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import SettingPc from '@/components/ViewComponent/Setting/SettingPc.vue';

@Component<Setting>({
  components: { SettingPc },
})
export default class Setting extends Vue {}
